module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 161.1da7ba84.png";